import { createContext, useContext } from "react";

// "confirming" while the paid order awaits its webhook, "late" once the
// minute ran out on it still pending.
export type OrderPaymentCheck = "confirming" | "late" | null;

export const OrderPaymentCheckContext = createContext<OrderPaymentCheck>(null);

/** The payment check of the order paid last (OrderPaymentProvider). */
export const useOrderPaymentCheck = () => useContext(OrderPaymentCheckContext);
